import './load.css';

function Load(){
    return(
        <section className="section_carroseul">
            <section className="load">
                <h2>Carregando</h2>
            </section>
        </section>
    )
}

export default Load;